import api from '@/api';

const resource = 'merenda/preparacao';

export default {
  criarPreparacao( data ) {
    return api.post( `${resource}`, data );
  },

  editarPreparacao( data ) {
    return api.put( `${resource}/${data.identificadorpreparacao}`, data);
  },

  deletarPreparacao( id ) {
    return api.delete(`${resource}/${id}`);
  },

  buscarPreparacao() {
    return api.get( `${resource}` );
  }
};
